import { createSlice } from '@reduxjs/toolkit';
import {
  createAssetRequest,
  fetchAllAssetRequests,
  fetchAssetRequestById,
  updateAssetRequest,
  deleteAssetRequest,
  fetchAssetRequestsByEmployeeId
} from './assetRequestAction';
import { AssetRequestState } from './assetRequestTypes';

const initialState: AssetRequestState = {
  assetRequests: [],
  selectedAssetRequest: undefined,
  AssetByEmployee: [],
  loadingStates: {
    create: false,
    fetchAll: false,
    fetchById: false,
    fetchByEmployee: false,
    update: false,
    delete: false,
  },
  errors: {}
};

const assetRequestSlice = createSlice({
  name: 'assetRequest',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      // Create
      .addCase(createAssetRequest.pending, (state) => {
        state.loadingStates.create = true;
        state.errors.create = undefined;
      })
      .addCase(createAssetRequest.fulfilled, (state, action) => {
        state.loadingStates.create = false;
        state.assetRequests.push(action.payload.data);
      })
      .addCase(createAssetRequest.rejected, (state, action) => {
        state.loadingStates.create = false;
        state.errors.create = action.payload as string;
      })

      // Fetch All
      .addCase(fetchAllAssetRequests.pending, (state) => {
        state.loadingStates.fetchAll = true;
        state.errors.fetchAll = undefined;
      })
      .addCase(fetchAllAssetRequests.fulfilled, (state, action) => {
        state.loadingStates.fetchAll = false;
        state.assetRequests = action.payload.data;
      })
      .addCase(fetchAllAssetRequests.rejected, (state, action) => {
        state.loadingStates.fetchAll = false;
        state.errors.fetchAll = action.payload as string;
      })

      // Fetch By ID
      .addCase(fetchAssetRequestById.pending, (state) => {
        state.loadingStates.fetchById = true;
        state.errors.fetchById = undefined;
      })
      .addCase(fetchAssetRequestById.fulfilled, (state, action) => {
        state.loadingStates.fetchById = false;
        state.selectedAssetRequest = action.payload.data;
      })
      .addCase(fetchAssetRequestById.rejected, (state, action) => {
        state.loadingStates.fetchById = false;
        state.errors.fetchById = action.payload as string;
      })

      // Update
      .addCase(updateAssetRequest.pending, (state) => {
        state.loadingStates.update = true;
        state.errors.update = undefined;
      })
      .addCase(updateAssetRequest.fulfilled, (state, action) => {
        state.loadingStates.update = false;
        const index = state.assetRequests.findIndex(ar => ar.Id === action.payload.Id);
        if (index !== -1) state.assetRequests[index] = action.payload.data;
      })
      .addCase(updateAssetRequest.rejected, (state, action) => {
        state.loadingStates.update = false;
        state.errors.update = action.payload as string;
      })
      // Fetch By Employee
      .addCase(fetchAssetRequestsByEmployeeId.pending, (state) => {
        state.loadingStates.fetchByEmployee = true;
        state.errors.fetchByEmployee = undefined;
      })
      .addCase(fetchAssetRequestsByEmployeeId.fulfilled, (state, action) => {
        state.loadingStates.fetchByEmployee = false;
        state.AssetByEmployee = action.payload.data;
      })
      .addCase(fetchAssetRequestsByEmployeeId.rejected, (state, action) => {
        state.loadingStates.fetchByEmployee = false;
        state.errors.fetchByEmployee = action.payload as string;
      })
      // Delete
      .addCase(deleteAssetRequest.pending, (state) => {
        state.loadingStates.delete = true;
        state.errors.delete = undefined;
      })
      .addCase(deleteAssetRequest.fulfilled, (state, action) => {
        state.loadingStates.delete = false;
        state.assetRequests = state.assetRequests.filter(ar => ar.Id !== action.payload.Id);
      })
      .addCase(deleteAssetRequest.rejected, (state, action) => {
        state.loadingStates.delete = false;
        state.errors.delete = action.payload as string;
      });
  }
});

export default assetRequestSlice.reducer;
